import {Action, Reducer} from 'redux';
import {POCTool} from '../../models/IPOCToolsContentManagement';
import {
  CLEAR_POCTOOL,
  KnownAction,
  SET_POCTOOLCONTENT,
  SET_POCTOOLSUMMARY,
  SET_SUPERPOCTOOLCONTENT,
} from './poctoolsContentManagementActions';

//// ------------- GLOBAL STATE ----------- ////
export interface poctoolsContentManagementState {
  pointOfCareTool: POCTool;
  displayPocToolContent: any[];
}

//// ---------------- REDUCER ------------- ////
export const reducer: Reducer<poctoolsContentManagementState> = (
  state: poctoolsContentManagementState | undefined,
  incomingAction: Action,
): poctoolsContentManagementState => {
  if (state === undefined) {
    return {
      pointOfCareTool: {
        id: '',
        name: '',
        description: '',
        image: {
          file: null,
          fileName: null,
          url: null,
        },
        categories: [],
        miniTools: [],
      },
      //here we store the final object
      displayPocToolContent: [],
      //here we store the simplified CONTENT array for creating and changing the POCTools
    };
  }
  const action = incomingAction as KnownAction;
  switch (action.type) {
    case SET_POCTOOLSUMMARY:
      return {
        ...state,
        pointOfCareTool: {
          id: action.POCToolSummary.id,
          name: action.POCToolSummary.name,
          description: action.POCToolSummary.description,
          image: action.POCToolSummary.image.url
            ? {
                url: action.POCToolSummary.image.url,
              }
            : {
                file: action.POCToolSummary.image.file,
                fileName: action.POCToolSummary.image.fileName,
              },
          miniTools: [],
          categories: [],
        },
      };
    case SET_POCTOOLCONTENT:
      return {
        ...state,
        pointOfCareTool: {
          ...state.pointOfCareTool,
          miniTools: [],
          categories: action.POCToolContent,
        },
        displayPocToolContent: action.displayPocToolContent,
      };
    case SET_SUPERPOCTOOLCONTENT:
      return {
        ...state,
        pointOfCareTool: {
          ...state.pointOfCareTool,
          categories: [],
          miniTools: action.POCToolContent,
        },
        displayPocToolContent: action.displayPocToolContent,
      };
    case CLEAR_POCTOOL:
      return {
        pointOfCareTool: {
          id: '',
          name: '',
          description: '',
          image: null,
          categories: [],
          miniTools: [],
        },
        displayPocToolContent: [],
      };
    default:
      return state;
  }
};
